// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'alarms/:pathMatch(.*)?',
        name: consts.routerNames.alarms.main,
        meta: {
            mainRouteName: consts.routerNames.alarms.main,
            list: 'AlarmsList',
            showMap: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/AlarmsPage.vue')
    },
];

export default routes;